import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userLogin, setPassword as setPasswordService, userSignup } from "../../utilities/services/login";

// Async thunk for user signup
export const signupUser = createAsyncThunk(
  "auth/signupUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await userSignup(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error || "An error occurred");
    }
  }
);

// Async thunk for login
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await userLogin(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error || "An error occurred");
    }
  }
);

// Async thunk for setting a new password
export const setNewUserPassword = createAsyncThunk(
  "auth/setPassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await setPasswordService(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error || "An error occurred");
    }
  }
);

// Create the auth slice
const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    isLoading: false,
    success: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
    },
    resetAuthState: (state) => {
      state.isLoading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Signup
      .addCase(signupUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(signupUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
        state.success = true;
      })
      .addCase(signupUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Login
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Set New Password
      .addCase(setNewUserPassword.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(setNewUserPassword.fulfilled, (state) => {
        state.isLoading = false;
        state.success = true;
      })
      .addCase(setNewUserPassword.rejected, (state, action) => {
        state.isLoading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { logout, resetAuthState } = authSlice.actions;
export default authSlice.reducer;
